var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgProfileLinkedIn = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 44,
  height: 48,
  viewBox: "0 0 44 48",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 22,
  cy: 24,
  r: 22,
  fill: "#6D9AEB",
  fillOpacity: 0.2
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M34.5713 25.0623V33.4288H29.7953V25.6242C29.7953 23.6668 29.1078 22.3269 27.3617 22.3269C26.8258 22.3331 26.3049 22.5064 25.8695 22.8234C25.4341 23.1405 25.1054 23.5858 24.928 24.099C24.8047 24.4811 24.751 24.8829 24.7699 25.2846V33.4288H19.9878C19.9878 33.4288 20.0547 20.2152 19.9878 18.8445H24.7699V20.913L24.7334 20.9624H24.7699V20.913C25.2006 20.1501 25.8296 19.522 26.5882 19.0974C27.3467 18.6727 28.2057 18.4677 29.0713 18.5049C32.2168 18.5049 34.547 20.5857 34.547 25.0623H34.5713ZM12.5713 33.4288H17.3595V18.8445H12.5835L12.5713 33.4288ZM17.4933 13.8986C17.4933 14.3871 17.3506 14.8646 17.0832 15.2708C16.8158 15.677 16.4357 15.9935 15.991 16.1805C15.5463 16.3674 15.057 16.4163 14.5849 16.321C14.1128 16.2257 13.6792 15.9905 13.3389 15.6451C12.9985 15.2997 12.7667 14.8596 12.6728 14.3805C12.5789 13.9014 12.6271 13.4048 12.8113 12.9535C12.9955 12.5022 13.3074 12.1164 13.7076 11.8451C14.1078 11.5737 14.5783 11.4288 15.0597 11.4288C15.7051 11.4288 16.3241 11.689 16.7805 12.1522C17.2369 12.6154 17.4933 13.2436 17.4933 13.8986Z",
  fill: "#557EC9"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgProfileLinkedIn);
export default ForwardRef;